import {
  IIkCardSelectableIconItem
} from '@infomaniak/angular-common/src/components/ik-card-selectable-icon-item/ik-card-selectable-icon-item.interfaces';
import { translate } from '@ngneat/transloco';

export function getPartnerIkCardSelectableIconItemForManageUsers(): IIkCardSelectableIconItem {
  return {
    icon: 'icon-users',
    title: translate('Gestion des utilisateurs'),
    description: translate('Vous pourrez gerer les utilisateurs et les equipes de travail de ce client.'),
  };
}
